import PLP from "src/themes/zenith/pages/PLP.vue"

export const PAGES = {
  HOMEPAGE: 'homepage',
  FAQ: 'faq',
  NEWS: 'news',
  COLLECTION: 'collection',
  COLLECTION_LANDING_CHRONOMASTER: 'collection-landing-chronomaster',
  DEFY_EXTREME: 'defy-extreme',
  DEFY_5HZ: 'defy5hz',
  PRODUCT: 'product',
  BRAND: 'brand',
  SERVICE: 'service',
  SELECTION: 'selection',
  SIMPLE_PAGE: 'simple-page',
  PANTONE: 'landing-pantone',
  LIVETOUR: 'livetour',
  COMMITMENT: 'commitment',
  TIMETOREACHYOURSTAR: 'time-to-reach-your-star',
  NEWS_LANDING: 'news-landing',
  GLOBAL_SETTINGS: 'global-settings',
  POPUP: 'popup',
  PLP: 'plp',
  CLP: 'clp',
  WATCH_EXPLORER: 'watch-explorer',
  WATCH_EXPLORER_RESULTS: 'watch-explorer-results'
}
export const BLOCKS = {
  BASELINE_GIF: 'baseline-gif',
  COLLECTIONS_THUMBS: 'collections-thumbs',
  STORE_LOCATOR_WIDGET: 'store-locator-widget',
  TOP_MESSAGE: 'top-message',
  PLP_EDITORIAL_BLOCK: 'plp_editorial_block',
}
export const UIDS = {
  HOMEPAGE: 'homepage',
  NEWS_LANDING: 'news-landing',
  PANTONE: 'pantone',
  COLLECTION_LANDING_CHRONOMASTER: 'chronomaster',
  DEFY_EXTREME: 'defy-extreme',
  DEFY_5HZ: 'defy-skyline',
  COMMITMENT: 'commitment',
  TIMETOREACHYOURSTAR: 'time-to-reach-your-star',
  FAQ: 'faq',
  GLOBAL_SETTINGS: 'global-settings',
  POPUP: 'popup',
  WATCH_EXPLORER: 'watch-explorer'
}
